module.exports = __webpack_public_path__ + "img/diamonds-without.eae236b.webp";